import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './user'
import systemStore from './system'
import commonStore from './common'
import articleStore from './article'
import messageStore from './message'
Vue.use(Vuex)
export default new Vuex.Store({
  modules: {
    userStore,
    commonStore,
    systemStore,
    articleStore,
    messageStore,
  },

})